import { isDOM } from '@app/shared/predicates'
import { onEachPageTeardown } from '@app/adapters/page-teardown'

function toggleOneTrustInfoDisplay(event: Event): void {
  event.preventDefault()
  event.stopPropagation()

  if (window.OneTrust) {
    window.OneTrust.ToggleInfoDisplay()
  }
}

function addOpenPreferencesListener(doc: Document): void {
  const button = doc.querySelector(
    '[data-behaviour="open-cookie-center"]'
  ) as HTMLElement

  if (!button) {
    return
  }

  button.removeEventListener('click', toggleOneTrustInfoDisplay)
  button.addEventListener('click', toggleOneTrustInfoDisplay)
}

let timeoutId: ReturnType<typeof setTimeout> | null
let initializedCookieBanner: boolean = false

function tryToReloadBanner(doc: Document): void {
  if (timeoutId) {
    clearTimeout(timeoutId)
  }

  timeoutId = setTimeout(function () {
    const otConsentSdk = doc.getElementById('onetrust-consent-sdk')
    if (otConsentSdk) {
      otConsentSdk.remove()
    }

    if (!window.OneTrust) {
      return
    }

    window.OneTrust.Init()
    window.OneTrust.LoadBanner()
    initializedCookieBanner = true

    timeoutId = null
  }, 1000)
}

function setupBannerReload(doc: Document): void {
  addOpenPreferencesListener(doc)

  if (window.OneTrust) {
    tryToReloadBanner(doc)
  }
}

export default function setupReloadOTBanner(): void {
  window.onDomLoad(($dom) => {
    if (isDOM($dom[0])) {
      setupBannerReload($dom[0])
    }
  })

  onEachPageTeardown(() => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    if (window.OneTrust && initializedCookieBanner) {
      // If we don't close it, event listeners are still present
      // while underlying elements are not and this causes errors.
      window.OneTrust.Close()
      initializedCookieBanner = false
    }
  })
}

// Export for testing purposes
export { tryToReloadBanner, addOpenPreferencesListener, setupBannerReload }
